var map = {
	"./1taskStatus.svg": "3bf6",
	"./2taskStatus.svg": "e4b8",
	"./3taskStatus.svg": "2100",
	"./4taskStatus.svg": "1769",
	"./5taskStatus.svg": "f574",
	"./6taskStatus.svg": "1f09",
	"./7taskStatus.svg": "fb39"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0476";